// GraphQL Client
import { ApolloClient, InMemoryCache, ApolloLink, from } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { setContext } from "@apollo/client/link/context";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import { GRAPHQL_URI } from "./graphqlURI";
import { login, getIdToken } from "../../utils/authHelpers";

const graphqlURI = GRAPHQL_URI;

/**
 * @description Capture errors in the apollo client
 * @param {*} graphQLErrors - GraphQL related errors
 * @param {*} networkError - Network related errors
 */
const errorHandler = ({ graphQLErrors, networkError }) => {
  let isAuthError = false;
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path, extensions }) => {
      console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
      if (extensions.code === "UNAUTHENTICATED") isAuthError = true;
    });
  // Redirect user the login page
  if (isAuthError) login();
  if (networkError) console.error(`[Network error]: ${networkError}`);
};

/**
 * @description Enhanced Apollo HttpLink which has the apollo-upload-client
 */
const uploadLink = createUploadLink({ uri: graphqlURI });

/**
 * @description Authorisation context for Auth0
 */
const authLink = setContext((_, { headers }) => ({
  headers: {
    ...headers,
    authorization: getIdToken(),
    "Apollo-Require-Preflight": "true",
  },
}));

/**
 * @description The Apollo Client
 */
const client = new ApolloClient({
  link: from([onError(errorHandler), authLink, uploadLink]),
  cache: new InMemoryCache(),
});

export default client;
